import moment from "moment";
import FormStore from "../Store/forms";

const getUserDataJSON = () => {
  let UserDataJSONSelf = {
    appNo: "",
    advisorCode: "",
    source: "BOLEBINEW",
    sourceKey: "BOLEBINEWKEY",
    salesDataReqd: "N",
    dependentFlag: FormStore.calc_buyingFor === "Self" ? "N" : "Y",
    sourceTransactionId: "",
    sourceOfFund: "Salary",
    sourceOfFundDesc: "",
    clientId: "",
    uidId: window.Glb_UID,
    buyersPinCode: "",
    sellersPinCode: "",
    "appform-details": {
      frstNm: "",
      lstNm: "",
      preferred_identity_proof: "",
      preferred_age_proof: "",
      mrtlSts: "696",
      education: "680",
      occ: "",
      occDesc: "",
      nameOfOrg: "",
      orgType: "",
      orgTypeDesc: "",
      myProfession: "",
      orgNameDesc: "",
      panNo: "",
      annIncme: "625000",
      mobileNumber: "9999999999",
      indsTypeQuestion: "",
      indsType: "",
    },
    Nominee: {
      marriedProtectAct: "",
      bene_fname1: "",
      bene_lname1: "",
      bene_dob1: "",
      bene_reln1: "",
      bene_share1: "",
      bene_fname2: "",
      bene_lname2: "",
      bene_dob2: "",
      bene_reln2: "",
      bene_share2: "",
      bene_fname3: "",
      bene_lname3: "",
      bene_dob3: "",
      bene_reln3: "",
      bene_share3: "",
      bene_fname4: "",
      bene_lname4: "",
      bene_dob4: "",
      bene_reln4: "",
      bene_share4: "",
      bene_fname5: "",
      bene_lname5: "",
      bene_dob5: "",
      bene_reln5: "",
      bene_share5: "",
      bene_fname6: "",
      bene_lname6: "",
      bene_dob6: "",
      bene_reln6: "",
      bene_share6: "",
      nominee_chosen: "",
      nominee_declaration: "",
      nominee_other_reason: "",
      nomineeEmailId: "",
      nomineeMobile: "",
      nomineeAccountHolderName: "",
      nomineeAccountNumber: "",
      nomineeIfsc: "",
      nomineeMicrCode: "",
      nomineeBankname: "",
      nomineeAccountType: "Savings",
      isNomineeBankDetailsEnabled: "No",
      trust_type1: "",
      trust_name1: "",
      trust_address1: "",
      trust_city1: "",
      trust_state1: "",
      trust_dob1: "",
      trust_pincode1: "",
      trust_accountHoldername1: "",
      trust_bankname1: "",
      trust_accountnumber1: "",
      trust_accounttype1: "",
      trust_micrCode1: "",
      trust_ifsc1: "",
      trust_type2: "",
      trust_name2: "",
      trust_address2: "",
      trust_city2: "",
      trust_state2: "",
      trust_dob2: "",
      trust_pincode2: "",
      trust_accountHoldername2: "",
      trust_bankname2: "",
      trust_accountnumber2: "",
      trust_accounttype2: "",
      trust_micrCode2: "",
      trust_ifsc2: "",
      trust_type3: "",
      trust_name3: "",
      trust_address3: "",
      trust_city3: "",
      trust_state3: "",
      trust_dob3: "",
      trust_pincode3: "",
      trust_accountHoldername3: "",
      trust_bankname3: "",
      trust_accountnumber3: "",
      trust_accounttype3: "",
      trust_micrCode3: "",
      trust_ifsc3: "",
      trust_type4: "",
      trust_name4: "",
      trust_address4: "",
      trust_city4: "",
      trust_state4: "",
      trust_dob4: "",
      trust_pincode4: "",
      trust_accountHoldername4: "",
      trust_bankname4: "",
      trust_accountnumber4: "",
      trust_accounttype4: "",
      trust_micrCode4: "",
      trust_ifsc4: "",
      trust_type5: "",
      trust_name5: "",
      trust_address5: "",
      trust_city5: "",
      trust_state5: "",
      trust_dob5: "",
      trust_pincode5: "",
      trust_accountHoldername5: "",
      trust_bankname5: "",
      trust_accountnumber5: "",
      trust_accounttype5: "",
      trust_micrCode5: "",
      trust_ifsc5: "",
      trust_type6: "",
      trust_name6: "",
      trust_address6: "",
      trust_city6: "",
      trust_state6: "",
      trust_dob6: "",
      trust_pincode6: "",
      trust_accountHoldername6: "",
      trust_bankname6: "",
      trust_accountnumber6: "",
      trust_accounttype6: "",
      trust_micrCode6: "",
      trust_ifsc6: "",
      nomineefrstNm: "",
      nomineelstNm: "",
      nomineeGender: "Female",
      relationship: "Wife",
      nomineeDob: "",
      appointeefrstNm: "",
      appointeelstNm: "",
      appointeeGender: "",
      appointeeRelationship: "",
      appointeeDob: "",
      appointeeEmailId: "",
      appointeeMobile: "",
      appointeeAccountHolderName: "",
      appointeeAccountNumber: "",
      appointeeIfsc: "",
      appointeeMicrCode: "",
      appointeeBankname: "",
      appointeeAccountType: "Savings",
      isAppointeeBankDetailsEnabled: "No",
      insuranceInfos: "No",
      cmpany1: "",
      sum1: "",
      cmpany2: "",
      sum2: "",
      cmpany3: "",
      sum3: "",
      cmpany4: "",
      sum4: "",
      cmpany5: "",
      sum5: "",
      dependentInsuranceInfos: "No",
      deInCmpany1: "",
      deSum1: "",
      deIncome1: "",
      deInCmpany2: "",
      deSum2: "",
      deIncome2: "",
      deInCmpany3: "",
      deSum3: "",
      deIncome3: "",
      deInCmpany4: "",
      deSum4: "",
      deIncome4: "",
      deInCmpany5: "",
      deSum5: "",
      deIncome5: "",
    },
    isSuitabilityReq: "Y",
    proposerInfos: {
      frstNm: "",
      lstNm: "",
      mrtlSts: "",
      dob: moment(window.UserInput.dob, "DD/MM/YYYY")
        .format("DD-MMM-YYYY")
        .toUpperCase(),
      gender: window.UserInput.gender,
      isStaff: "0",
      mobNo: window.UserInput.MobileNo,
      email: window.UserInput.EmailId,
    },
    productSelection: {
      option: "Lump-Sum",
      productId: "KV",
      productName: "ICICI Pru Save N Grow",
      productType: "TRADITIONAL",
      deathBenefitOption: "Deferred Income",
      premiumPayingFrequency: "Yearly",
      premiumPayingTerm: "10",
      policyTerm: "81",
      pensionFrequency: "Yearly",
      sumAssured: "1370000",
      modalPremium: "100000",
      annualpremium: "100000",
      saMultiple: "13.7",
      premiumpaymentoption: "Limited Pay",
      selectedOption: "Special Date",
      specialDate: "26/Jan/2024",
      RetireMentAge: "99",
      isKeralaCess: "false",
      Goal: "true",
      familyBenefit: "false",
      loyaltyBenefit: "false",
      NPSFlag: "false",
      SWP: "false",
      PolicyEndDate: "16/Jan/2104",
      defermentPeriod: "1",
      policyCommencementDate: "26/Jan/2024",
      iPSDiscount: "true",
      NPSFlag: "false",
    },
    suitabilityMatrix: {
      income: "1000000",
      lifeStage: "single",
      financialAndFamilyGoals: "Savings",
      goalHorizon: "15",
      riskProfile: "Aggressive",
      paymentPreference: "RegularPay",
      insurancePortfolioHeld: 0,
    },
    paymentData: {
      pincode: "400097",
      option: "Lump-Sum",
      productId: "KV",
      extraAtsInfo: {
        fname: "abc",
        lname: "xyz",
        dob_str: moment(window.UserInput.dob, "DD/MM/YYYY")
          .format("DD-MMM-YYYY")
          .toUpperCase(),
        gender: window.UserInput.gender,
        sa: 2400000,
      },
    },
    additionalDetails: {
      partnerDataMap: {
        pagename: "savings : savengrow : life-long-calculator",
        pageURL:
          "https://www.icicilife.com/protection-saving-plans/capital-guarantee-solution-calculator.html",
      },
    },
    Communication: {
      address1: "",
      address2: "",
      address3: "",
      landmark: "",
      pinCode: "301001",
      city: "MACHARI",
      state: "35",
      country: "India",
      emailAddress: "test@gmail.com",
      addCommunication: "Yes",
      prmnt_address1: "",
      prmnt_address2: "",
      prmnt_address3: "",
      prmnt_landmark: "",
      prmnt_pinCode: "",
      prmnt_city: "",
      prmnt_state: "",
      prmnt_country: "India",
      preferred_address_proof: "",
      LA_Prop_ComAdd_chk: "No",
      LA_Prop_PerAdd_chk: "Yes",
    },
    "proposer-details": {
      propfrstNm: "",
      propLastNm: "",
      propFatherNm: "",
      propMotherNm: "",
      propSpouseNm: "",
      propMaritalStatus: "696",
      propRel: "Spouse",
      propDob: "",
      propGender: "Male",
      propEdu: "",
      propocc: "",
      propoccDesc: "",
      propnameOfOrg: "",
      proporgType: "",
      proporgTypeDesc: "",
      propmyProfession: "",
      proporgNameDesc: "",
      propMobileNumber: "",
      propEmailAddress: "",
      propPanNo: "",
      propannIncme: "1000000",
      propPreferred_identity_proof: "",
      propPreferred_age_proof: "",
      propPranNumber: "",
      isCDFDigitalReq: "YES",
      propIndsTypeQuestion: "No",
      propIndsType: "",
    },
  };
  let UserDataJSONRelative = {
    appNo: "",
    advisorCode: "",
    source: "BOLEBINEW",
    sourceKey: "BOLEBINEWKEY",
    salesDataReqd: "N",
    dependentFlag: FormStore.calc_buyingFor === "Self" ? "N" : "Y",
    sourceTransactionId: "",
    sourceOfFund: "Salary",
    sourceOfFundDesc: "",
    clientId: "",
    uidId: window.Glb_UID,
    buyersPinCode: "",
    sellersPinCode: "",
    isSuitabilityReq: "Y",
    proposerInfos: {
      frstNm: "",
      lstNm: "",
      mrtlSts: "",
      dob: moment(window.UserInput.p_dob, "DD/MM/YYYY")
        .format("DD-MMM-YYYY")
        .toUpperCase(),
      gender: window.UserInput.p_gender,
      isStaff: "0",
      mobNo: window.UserInput.MobileNo,
      email: window.UserInput.EmailId,
    },
    lifeAssrdInfos: {
      frstNm: "",
      lstNm: "",
      mrtlSts: "",
      dob: moment(window.UserInput.dob, "DD/MM/YYYY")
        .format("DD-MMM-YYYY")
        .toUpperCase(),
      gender: window.UserInput.gender,
      isStaff: "0",
      mobNo: window.UserInput.MobileNo,
      email: window.UserInput.EmailId,
    },
    productSelection: {
      option: "Lump-Sum",
      productId: "KV",
      productName: "ICICI Pru Save N Grow",
      productType: "TRADITIONAL",
      deathBenefitOption: "Deferred Income",
      premiumPayingFrequency: "Yearly",
      premiumPayingTerm: "10",
      policyTerm: "81",
      pensionFrequency: "Yearly",
      sumAssured: "1370000",
      modalPremium: "100000",
      annualpremium: "100000",
      saMultiple: "13.7",
      premiumpaymentoption: "Limited Pay",
      selectedOption: "Special Date",
      specialDate: "26/Jan/2024",
      RetireMentAge: "99",
      isKeralaCess: "false",
      Goal: "true",
      familyBenefit: "false",
      loyaltyBenefit: "false",
      NPSFlag: "false",
      SWP: "false",
      PolicyEndDate: "16/Jan/2104",
      defermentPeriod: "1",
      policyCommencementDate: "26/Jan/2024",
      iPSDiscount: "true",
      NPSFlag: "false",
    },
    suitabilityMatrix: {
      income: "1000000",
      lifeStage: "single",
      financialAndFamilyGoals: "Savings",
      goalHorizon: "15",
      riskProfile: "Aggressive",
      paymentPreference: "RegularPay",
      insurancePortfolioHeld: 0,
    },
    paymentData: {
      pincode: "400097",
      extraAtsInfo: {
        fname: "abc",
        lname: "xyz",
        dob_str: "12-DEC-1994",
        gender: "Male",
        sa: 2400000,
      },
    },
    additionalDetails: {
      partnerDataMap: {
        pagename: "savings : savengrow : life-long-calculator",
        pageURL:
          " https://www.icicilife.com/protection-saving-plans/capital-guarantee-solution-calculator.html",
      },
    },
    "appform-details": {
      frstNm: "",
      lstNm: "",
      preferred_identity_proof: "",
      preferred_age_proof: "",
      mrtlSts: "696",
      education: "680",
      occ: "",
      occDesc: "",
      nameOfOrg: "",
      orgType: "",
      orgTypeDesc: "",
      myProfession: "",
      orgNameDesc: "",
      panNo: "",
      annIncme: "625000",
      mobileNumber: "9999999999",
      indsTypeQuestion: "",
      indsType: "",
    },
    Nominee: {
      marriedProtectAct: "",
      bene_fname1: "",
      bene_lname1: "",
      bene_dob1: "",
      bene_reln1: "",
      bene_share1: "",
      bene_fname2: "",
      bene_lname2: "",
      bene_dob2: "",
      bene_reln2: "",
      bene_share2: "",
      bene_fname3: "",
      bene_lname3: "",
      bene_dob3: "",
      bene_reln3: "",
      bene_share3: "",
      bene_fname4: "",
      bene_lname4: "",
      bene_dob4: "",
      bene_reln4: "",
      bene_share4: "",
      bene_fname5: "",
      bene_lname5: "",
      bene_dob5: "",
      bene_reln5: "",
      bene_share5: "",
      bene_fname6: "",
      bene_lname6: "",
      bene_dob6: "",
      bene_reln6: "",
      bene_share6: "",
      nominee_chosen: "",
      nominee_declaration: "",
      nominee_other_reason: "",
      nomineeEmailId: "",
      nomineeMobile: "",
      nomineeAccountHolderName: "",
      nomineeAccountNumber: "",
      nomineeIfsc: "",
      nomineeMicrCode: "",
      nomineeBankname: "",
      nomineeAccountType: "Savings",
      isNomineeBankDetailsEnabled: "No",
      trust_type1: "",
      trust_name1: "",
      trust_address1: "",
      trust_city1: "",
      trust_state1: "",
      trust_dob1: "",
      trust_pincode1: "",
      trust_accountHoldername1: "",
      trust_bankname1: "",
      trust_accountnumber1: "",
      trust_accounttype1: "",
      trust_micrCode1: "",
      trust_ifsc1: "",
      trust_type2: "",
      trust_name2: "",
      trust_address2: "",
      trust_city2: "",
      trust_state2: "",
      trust_dob2: "",
      trust_pincode2: "",
      trust_accountHoldername2: "",
      trust_bankname2: "",
      trust_accountnumber2: "",
      trust_accounttype2: "",
      trust_micrCode2: "",
      trust_ifsc2: "",
      trust_type3: "",
      trust_name3: "",
      trust_address3: "",
      trust_city3: "",
      trust_state3: "",
      trust_dob3: "",
      trust_pincode3: "",
      trust_accountHoldername3: "",
      trust_bankname3: "",
      trust_accountnumber3: "",
      trust_accounttype3: "",
      trust_micrCode3: "",
      trust_ifsc3: "",
      trust_type4: "",
      trust_name4: "",
      trust_address4: "",
      trust_city4: "",
      trust_state4: "",
      trust_dob4: "",
      trust_pincode4: "",
      trust_accountHoldername4: "",
      trust_bankname4: "",
      trust_accountnumber4: "",
      trust_accounttype4: "",
      trust_micrCode4: "",
      trust_ifsc4: "",
      trust_type5: "",
      trust_name5: "",
      trust_address5: "",
      trust_city5: "",
      trust_state5: "",
      trust_dob5: "",
      trust_pincode5: "",
      trust_accountHoldername5: "",
      trust_bankname5: "",
      trust_accountnumber5: "",
      trust_accounttype5: "",
      trust_micrCode5: "",
      trust_ifsc5: "",
      trust_type6: "",
      trust_name6: "",
      trust_address6: "",
      trust_city6: "",
      trust_state6: "",
      trust_dob6: "",
      trust_pincode6: "",
      trust_accountHoldername6: "",
      trust_bankname6: "",
      trust_accountnumber6: "",
      trust_accounttype6: "",
      trust_micrCode6: "",
      trust_ifsc6: "",
      nomineefrstNm: "",
      nomineelstNm: "",
      nomineeGender: "Female",
      relationship: "Wife",
      nomineeDob: "",
      appointeefrstNm: "",
      appointeelstNm: "",
      appointeeGender: "",
      appointeeRelationship: "",
      appointeeDob: "",
      appointeeEmailId: "",
      appointeeMobile: "",
      appointeeAccountHolderName: "",
      appointeeAccountNumber: "",
      appointeeIfsc: "",
      appointeeMicrCode: "",
      appointeeBankname: "",
      appointeeAccountType: "Savings",
      isAppointeeBankDetailsEnabled: "No",
      insuranceInfos: "No",
      cmpany1: "",
      sum1: "",
      cmpany2: "",
      sum2: "",
      cmpany3: "",
      sum3: "",
      cmpany4: "",
      sum4: "",
      cmpany5: "",
      sum5: "",
      dependentInsuranceInfos: "No",
      deInCmpany1: "",
      deSum1: "",
      deIncome1: "",
      deInCmpany2: "",
      deSum2: "",
      deIncome2: "",
      deInCmpany3: "",
      deSum3: "",
      deIncome3: "",
      deInCmpany4: "",
      deSum4: "",
      deIncome4: "",
      deInCmpany5: "",
      deSum5: "",
      deIncome5: "",
    },
    Communication: {
      address1: "",
      address2: "",
      address3: "",
      landmark: "",
      pinCode: "301001",
      city: "MACHARI",
      state: "35",
      country: "India",
      emailAddress: "test@gmail.com",
      addCommunication: "Yes",
      prmnt_address1: "",
      prmnt_address2: "",
      prmnt_address3: "",
      prmnt_landmark: "",
      prmnt_pinCode: "",
      prmnt_city: "",
      prmnt_state: "",
      prmnt_country: "India",
      preferred_address_proof: "",
      LA_Prop_ComAdd_chk: "No",
      LA_Prop_PerAdd_chk: "Yes",
    },
    "proposer-details": {
      propfrstNm: "",
      propLastNm: "",
      propFatherNm: "",
      propMotherNm: "",
      propSpouseNm: "",
      propMaritalStatus: "696",
      propRel: "Spouse",
      propDob: "",
      propGender: "Male",
      propEdu: "",
      propocc: "",
      propoccDesc: "",
      propnameOfOrg: "",
      proporgType: "",
      proporgTypeDesc: "",
      propmyProfession: "",
      proporgNameDesc: "",
      propMobileNumber: "",
      propEmailAddress: "",
      propPanNo: "",
      propannIncme: "1000000",
      propPreferred_identity_proof: "",
      propPreferred_age_proof: "",
      propPranNumber: "",
      isCDFDigitalReq: "YES",
      propIndsTypeQuestion: "No",
      propIndsType: "",
    },
  };
  const UserDataJSON =
    FormStore.calc_buyingFor === "Self"
      ? UserDataJSONSelf
      : UserDataJSONRelative;
  console.warn("Data for Payment", UserDataJSON);
  console.log("Data for Payment", UserDataJSON);
  return UserDataJSON;
};

export default getUserDataJSON;
